<template>
  <div>
    <label v-if="label" class="block text-gray-400 mb-2" :for="id">{{ label }}:</label>
    <textarea :id="id" ref="input" v-bind="$attrs" class="textarea-input" :class="{ error: error }" :value="value" @input="$emit('input', $event.target.value)" @keyup.enter.exact="$emit('enterPressed')"/>
    <div v-if="dataError" class="text-red-500 text-sm mt-1">{{ dataError }}</div>
  </div>
</template>

<script>
  export default {
    inheritAttrs: false,
    props: {
      id: {
        type: String,
        default() {
          return `textarea-input-${this._uid}`
        },
      },
      value: String,
      label: String,
      dataError: String,
      autosize: {
        type: Boolean,
        default: false,
      },
    },
    mounted() {
      if (this.autosize) {
        autosize(this.$refs.input)
      }
    },
    methods: {
      focus() {
        this.$refs.input.focus()
      },
      select() {
        this.$refs.input.select()
      },
    },
  }
</script>